import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import RightHolderProfileForm from './RightHolderProfileForm'
import RightHolderProfileFormSkeleton from './RightHolderProfileForm/Skeleton'

import { clearSelfAccount, getSelfAccount } from '../../../modules/actions/selfAccounts'

import { selfAccountIsLoadingSelector } from '../../../modules/selectors/selfAccounts'
import { selectedPartnershipRightsHolderIdSelector } from '../../../modules/selectors/partnerships'

import useCommonStyles from '../../../styles/common/listPage'
import useStyles from '../EditProfile/styles'

const RightHolderProfile = () => {
  const commonClasses = useCommonStyles()
  const classes = useStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const rightHolderDataLoading = useSelector(selfAccountIsLoadingSelector)
  const rightHolderAccountId = useSelector(selectedPartnershipRightsHolderIdSelector)

  useEffect(() => {
    if (rightHolderAccountId) {
      dispatch(getSelfAccount(rightHolderAccountId))
    }
  }, [dispatch, rightHolderAccountId])

  useEffect(() => {
    return () => {
      dispatch(clearSelfAccount())
    }
  }, [dispatch])

  return (
    <>
      <div className={classnames(commonClasses.heading, classes.editProfileHeading)}>
        <h3 className={commonClasses.title}>{t('Profile')}</h3>
      </div>
      {rightHolderDataLoading ? <RightHolderProfileFormSkeleton /> : <RightHolderProfileForm />}
    </>
  )
}

export default RightHolderProfile
